<template>
    <y-auth
        type="modern"
        v-bind="{ ...props }"
        class="m-auth"
        @back="backToLogin"
    />
</template>

<script>
    import PageMixin from '@nodes/mixins/Page';
    import { YAuth } from '@rogues/index.ts';

    export default {
        name: 'ForgetPage',

        components: {
            YAuth,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                pageTitle: this.$t('auth.forget.titles.forget_request'),

                props: {
                    step      : 'forget',
                    color     : 'primary',
                    img       : this.$settings('content.auth-image').link,
                    logo      : this.$settings('site_logos.main.link'),
                    logoAlt   : this.$settings('site_title.site_title'),
                    authTitle : this.$t('auth.title'),
                    authDesc  : this.$t('auth.forget.subtitle'),
                    contactTel: this.$settings('contact_details').elements[0].fixed_tel[this.$i18n.locale]
                        ? this.$settings('contact_details').elements[0].fixed_tel[this.$i18n.locale][0]
                        : this.$settings('contact_details').elements[0].fixed_tel.fa[0],
                    titles          : this.$t('auth.forget.titles'),
                    descriptions    : this.$t('auth.forget.descriptions'),
                    tokenTrans      : this.$t('auth.forget.token'),
                    buttonsTrans    : this.$t('auth.forget.buttons'),
                    formFooter      : this.$settings('copy_right.copy_right'),
                    loginAfterForget: true,
                    quarkinoBranding: true,
                },
                
            };
        },

        methods: {
            /**
             * Back to Login
             */
            backToLogin() {
                this.$router.push({
                    name: 'auth-login',
                });
            },
        },

    };
</script>

<style lang="scss" src="../scss/auth.scss"/>
